var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineLearning3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9222_3845)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9222_3845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H121V121H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9222_3845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3659 32.1132H99.7866H107.637C111.331 32.1132 114.326 35.1075 114.326 38.7989V104.25H6.6875V38.7989C6.6875 35.1075 9.68178 32.1132 13.3756 32.1132H21.2264H21.6471",
    stroke: "#020842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 95.9766H14.9531V40.3827H34.3746",
    stroke: "#020842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.626 40.3827H106.047V95.9766H31.3984",
    stroke: "#020842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8725 111.07H54.1333C50.474 111.07 47.5078 108.104 47.5078 104.445V104.245H73.498V104.445C73.498 108.104 70.5316 111.07 66.8725 111.07Z",
    stroke: "#020842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.229 104.247H1.77344V108.176C1.77344 113.545 6.12636 117.898 11.4962 117.898H109.506C114.875 117.898 119.229 113.545 119.229 108.176V104.247Z",
    stroke: "#020842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6271 38.8568V48.8409C86.6271 54.8052 83.0654 60.2175 77.5581 62.5068C66.6527 67.0394 54.3495 67.0394 43.4443 62.5068C37.9367 60.2175 34.375 54.8052 34.375 48.8409V38.8568",
    stroke: "#020842",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3413 10.1556L99.518 22.4328C103.365 24.4723 103.365 29.9859 99.518 32.0254L65.2433 50.1825C62.2774 51.7517 58.7277 51.7517 55.7618 50.1825L21.4871 32.0254C17.6397 29.9859 17.6397 24.4723 21.4871 22.4328L55.7618 4.27572C58.7277 2.7065 62.2774 2.7065 65.2433 4.27572L70.1495 6.87533",
    stroke: "#1DBF73",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 27.2325L75.7469 44.6192V68.1797",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7487 68.1793L71.9025 74.8409C70.5147 77.2451 72.2494 80.25 75.0253 80.25H76.4721C79.2478 80.25 80.9827 77.2451 79.5947 74.8409L75.7487 68.1793Z",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7812 87.7031H59.265",
    stroke: "#020842",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7812 80.25H47.5062",
    stroke: "#020842",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9222_3845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineLearning3);
export default __webpack_public_path__ + "static/media/online-learning 3.9f9ac0dcd0223185d39cbe33b8056552.svg";
export { ForwardRef as ReactComponent };